import React, { FC } from 'react'
import { LoginTermsBox, ConfirmTermsForm } from './styled'
import Typography from '@mui/material/Typography'
import LoginTermsAcceptForm from './LoginTermsAcceptForm'
import { CircularProgress } from '@mui/material'
import Box from '@mui/material/Box'
import { useDefaultComponentTools } from '../../../hooks/useDefaultComponentTools'

const LoginTerms: FC = () => {
	const { loading, setLoading, isMounted } = useDefaultComponentTools(true)

	const handleLoadTerms = (): void => {
		isMounted() && setLoading(false)
	}

	return (
		<LoginTermsBox>
			<Typography
				component={'h1'}
				variant={'h6'}
				sx={{
					color: 'text.secondary',
					fontWeight: 'normal',
					padding: '0.625rem 1.25rem',
				}}
			>
				TERMS OF SERVICE
			</Typography>

			<Box
				sx={{
					flex: 1,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					position: 'relative',
				}}
			>
				<object
					width={'100%'}
					height={'100%'}
					onLoad={handleLoadTerms}
					type={'text/html'}
					data={process.env.REACT_APP_TERMS_URL}
				/>
				{loading && (
					<CircularProgress sx={{ position: 'absolute' }} size={28} />
				)}
			</Box>

			<ConfirmTermsForm>
				<LoginTermsAcceptForm />
			</ConfirmTermsForm>
		</LoginTermsBox>
	)
}

export default LoginTerms
